import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { chiama } from './cliente.js';
import type { Sessione } from './sessione.js';

/**
 * Quello che sta nella pagina Profilo e non sta già nella sessione: da dove si
 * è entrati e da dove si è ancora dentro.
 */

export interface Accesso {
  quando: string;
  ipAddress: string | null;
  userAgent: string | null;
}

export interface SessioneAperta {
  /** Quella da cui si sta guardando: senza, non si sa quale riga sei tu. */
  corrente: boolean;
  apertaIl: string;
  ultimoUsoIl: string;
  ipAddress: string | null;
  userAgent: string | null;
}

export interface Profilo extends Sessione {
  /**
   * Le pagine che il servizio accetta come schermata iniziale. Comanda lui:
   * la pagina qui ci mette solo il nome leggibile.
   */
  homeScreens: string[];
  logins: Accesso[];
  sessions: SessioneAperta[];
}

const CHIAVE = ['profilo'] as const;

export function useProfilo() {
  return useQuery({
    queryKey: CHIAVE,
    queryFn: () => chiama<Profilo>('/api/me/profile'),
  });
}

export function useChiudiAltreSessioni() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () =>
      chiama<{ closed: number }>('/api/me/sessions/close-others', { metodo: 'POST' }),
    onSuccess: () => client.invalidateQueries({ queryKey: CHIAVE }),
  });
}
